module.exports = __webpack_public_path__ + "img/movie.ecff0f54.png";